/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateConfigurationRequest } from './UpdateConfigurationRequest';
import {
    UpdateConfigurationRequestFromJSON,
    UpdateConfigurationRequestFromJSONTyped,
    UpdateConfigurationRequestToJSON,
} from './UpdateConfigurationRequest';

/**
 * 
 * @export
 * @interface CreateConfigurationRequest
 */
export interface CreateConfigurationRequest extends UpdateConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateConfigurationRequest
     */
    redappName: string;
}

/**
 * Check if a given object implements the CreateConfigurationRequest interface.
 */
export function instanceOfCreateConfigurationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "redappName" in value;

    return isInstance;
}

export function CreateConfigurationRequestFromJSON(json: any): CreateConfigurationRequest {
    return CreateConfigurationRequestFromJSONTyped(json, false);
}

export function CreateConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConfigurationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...UpdateConfigurationRequestFromJSONTyped(json, ignoreDiscriminator),
        'redappName': json['redappName'],
    };
}

export function CreateConfigurationRequestToJSON(value?: CreateConfigurationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...UpdateConfigurationRequestToJSON(value),
        'redappName': value.redappName,
    };
}

